export default class DataValue {
	public value: number

	constructor(bytes:number) {
		this.value = bytes;
	}

	static fromGB(value:number):DataValue {
	   return new DataValue(((value * 1024) * 1024) * 1024);
	}

	static fromMB(value:number):DataValue {
		return new DataValue((value * 1024) * 1024);
	}

	static fromKB(value:number):DataValue {
		return new DataValue(value * 1024);
	}

	toGB():number {
		return ((this.value / 1024) / 1024) / 1024;
	}

	toMB():number {
		return (this.value / 1024) / 1024;
	}

	toKB():number {
		return this.value / 1024;
	}

	toB():number {
		return this.value;
	}

	toPrettyValue():string {
		return DataValue.getPrettyValue(this.value)
	}

	static toTB(value:number):number {
		return (((value / 1024) / 1024) / 1024) / 1024;
	}

	static toGB(value:number):number {
		return ((value / 1024) / 1024) / 1024;
	}

	static toMB(value:number):number {
		return (value / 1024) / 1024;
	}

	static toKB(value:number):number {
		return value / 1024;
	}

	static toB(value:number):number {
		return value;
	}

	static getPrettyValue(value:number, radix:number = 2, compact:boolean = false):string {
		let result = 0;
		let multiplier = "B"
		if(value < 1024) { result = value; multiplier = "B" }
		else if(value < (1024 * 1024)) { result = this.toKB(value); multiplier = "KB" }
		else if(value < ((1024 * 1024) * 1024)) { result = this.toMB(value); multiplier = "MB" }
		else if(value < (((1024 * 1024) * 1024) * 1024)) { result = this.toGB(value); multiplier = "GB" }
		else { result = this.toTB(value); multiplier = "TB" }

		let finalString = "0"
		if(compact) {
			if(value < ((1024 * 1024) * 1024)) {
				finalString = result.toFixed(0).replace(/\.00$/, '') + multiplier
			} 
			else if ( (((1024 * 1024) * 1024) * 1024) ) {
				finalString = result.toFixed(1).replace(/\.00$/, '') + multiplier
			} else {
				finalString = result.toFixed(2).replace(/\.00$/, '') + multiplier
			}

		} else {
			if(result.toString().length >= 3) {
				finalString = result.toFixed(radix).replace(/\.00$/, '') + multiplier
			}
			else if (result.toString().length >= 2) {
				finalString = result.toFixed(radix).replace(/\.00$/, '') + multiplier
			}
			else if (result.toString().length >= 1) {
				finalString = result.toFixed(radix).replace(/\.00$/, '') + multiplier
			}
		}
		
		
		return finalString
		
	}
}